<div class="modal-wrapper">
  <div class="modal-header">
    <h5 class="modal-title" ngbAutoFocus tabindex="0" [innerHtml]="title"></h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('cross click')"></button>
  </div>
  <div class="modal-body" [innerHtml]="body"></div>
  <div class="modal-footer">
    <button type="button" class="btn" [ngClass]="useDangerColor ? 'btn-danger' : 'btn-primary'" (click)="activeModal.close('ok')">{{okButton}}</button>
    @if (useTwoButtons) {
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">{{cancelButton}}</button>
    }
  </div>
</div>
